export default {
    STRING: 'string',
    BOOLEAN: 'boolean',
    CURRENCY: 'currency',
    INTEGER: 'integer',
    FLOAT: 'float',
    PERCENTAGE: 'percentage',
    DATE: 'date',
    DATETIME: 'datetime',
    TIME: 'time',
    TIMESTAMP: 'timestamp',
    JSON: 'json',
    FILE: 'file', // This is for SnapGrid, models use FieldType.FILE
    YES_NO: 'yes_no', // This is for SnapGrid, models use FieldType.YES_NO
    MULTI_INPUT: 'multi_input',
};
